const flagsPrefix = "VITE_FF_"

export const featureFlagIsActive = (flagName: string): boolean => {
    let key = flagName
    if (!key.startsWith(flagsPrefix)) {
        key = flagsPrefix + flagName
    }
    return (import.meta.env as Record<string, string>)[key] === "true"
}

export const getFeatureFlagValue = (flagName: string): string => {
    let key = flagName
    if (!key.startsWith(flagsPrefix)) {
        key = flagsPrefix + flagName
    }
    return (import.meta.env as Record<string, string>)[key] || ""
}
